import { isPlatformBrowser, NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, inject, Input, OnChanges, OnDestroy, OnInit, PLATFORM_ID, signal, SimpleChanges } from '@angular/core';
import { TruncatePipe } from "../../pipes/truncate.pipe";
import { Banner } from '../../../features/details/models/details.model';
import { TrainingUrl, WadhwaniUrl } from '../../enums/app.enums';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-banner',
  imports: [NgClass, TruncatePipe],
  templateUrl: './banner.html',
  styleUrl: './banner.scss'
})
export class BannerComponent implements OnInit, OnChanges, OnDestroy{
  environment = environment;
  private platformId = inject(PLATFORM_ID)
  private cdr = inject(ChangeDetectorRef)
  private isBrowser!:boolean

  currentIndex = signal(0);
  isPlaying = signal(false);
  totalSlides = signal(0);
  resizeTimeout: any;
  cardsPerView = signal(2); 
  autoplayInterval: any;

  @Input() banners: Banner[] = [];
  image: string = "https://jobs.bdjobs.com/images/elearning_list.svg";
  
  trainingUrl = TrainingUrl
  wadhwaniUrl = WadhwaniUrl
  slideGroups = signal<Banner[][]>([]);
  backgroundImageUrl=`url(${environment.bucketAssetUrl}/images/elearning_list.svg)`;
  constructor() {
    this.isBrowser = isPlatformBrowser(this.platformId)
    this.handleResize = this.handleResize.bind(this);
  }

  ngOnInit(): void {
    if(this.isBrowser){
      window.addEventListener('resize', this.handleResize);
    }
    this.setCardsPerView();
    this.initializeSlides();
    this.toggleAutoplay();
  }

  setCardsPerView() {
    if(!this.isBrowser) return ;
    const width = window.innerWidth;
    this.cardsPerView.set(width < 992 ? 1 : 2);
  }
  get slideWidth(): number {
    return this.isSmallScreen ? 100 : 50;
  }
  get isSmallScreen(): boolean {
    return this.isBrowser ? window.innerWidth < 992 : false
  }  
  

  handleResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.setCardsPerView(); 
      this.initializeSlides();
      this.cdr.detectChanges();
    }, 150);
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['banners']) {
      this.initializeSlides();
    }
  }

  initializeSlides() {
    const groupedSlides: Banner[][] = [];
    for (let i = 0; i < this.banners.length; i += this.cardsPerView()) {
      groupedSlides.push(this.banners.slice(i, i + this.cardsPerView()));
    }
    this.slideGroups.set([...groupedSlides, ...groupedSlides]);
    this.totalSlides.set(groupedSlides.length * 2);
  }

  

  nextSlide() {
    this.currentIndex.update(index => {
      const next = index + 1;
      if (next >= this.totalSlides()) {
        this.disableTransitionTemporarily();
        return 0;
      }
      return next;
    });
  }
  
  prevSlide() {
    this.currentIndex.update(index => {
      const prev = index - 1;
      if (prev < 0) {
        this.disableTransitionTemporarily();
        return this.totalSlides() - 1;
      }
      return prev;
    });
  }
  

  disableTransitionTemporarily() {
    if(!this.isBrowser) return ;
    const slider = document.querySelector('.flex.transition-transform') as HTMLElement;
    if (slider) {
      slider.style.transition = 'none';
      requestAnimationFrame(() => {
        slider.offsetHeight; 
        slider.style.transition = '';
      });
    }
  }
  
  toggleAutoplay() {
    if (this.isPlaying()) {
      clearInterval(this.autoplayInterval);
    } else {
      this.autoplayInterval = setInterval(() => this.nextSlide(), 3000);
    }
    this.isPlaying.set(!this.isPlaying());
  }

  ngOnDestroy(): void {
    if(this.isBrowser){
      window.removeEventListener('resize', this.handleResize);
    }
    
    clearTimeout(this.resizeTimeout);
    clearInterval(this.autoplayInterval);
  }
}
